import {
  Flex,
  Icon,
  LoadingSpinner,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Button } from 'src/design_system/molecules/button/Button'

type CardPreviewFooterProps = {
  primaryAction: {
    title: string
    onClick: () => void
    isLoading?: boolean
    loadingMessage?: string
  }
  secondaryAction?: { title: string; onClick: () => void }
  isMobile?: boolean
}

export const CardPreviewFooter = (props: CardPreviewFooterProps) => {
  const { primaryAction, secondaryAction, isMobile = false } = props
  const primaryFont = 'Montserrat, san serif'

  return (
    <Flex
      width="100%"
      justifyContent="space-evenly"
      columnGap="x2"
      outset={isMobile ? undefined : { bottom: 'x1' }}
      style={
        isMobile
          ? {
              position: 'sticky',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              padding: '12px 16px',
              paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
              margin: '8px 0px 0px 0px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.8)',
              boxShadow: '0 -8px 24px rgba(17, 24, 39, 0.15)',
              zIndex: 5,
            }
          : undefined
      }
    >
      {secondaryAction && (
        <Button
          padding="8px 12px"
          borderRadius="50rem"
          fill="#fff"
          onClick={secondaryAction.onClick}
        >
          <Icon name="leftChevron" size="small" primaryColor="#6B7280" />
          <Text
            type="body"
            content={secondaryAction.title}
            style={{
              fontFamily: primaryFont,
              fontSize: '.75rem',
              fontWeight: 700,
              color: '#6B7280',
            }}
          />
        </Button>
      )}
      <Button
        padding="8px 12px"
        isFullWidth={true}
        borderRadius="50rem"
        fill="#404040"
        onClick={primaryAction.onClick}
        isDisabled={primaryAction?.isLoading}
      >
        <Text
          type="body"
          content={
            primaryAction?.isLoading
              ? (primaryAction?.loadingMessage ?? 'Loading...')
              : primaryAction.title
          }
          style={{
            fontFamily: primaryFont,
            fontSize: '.75rem',
            fontWeight: 700,
            color: '#fff',
          }}
        />
        {primaryAction.isLoading && <LoadingSpinner size="small" />}
      </Button>
    </Flex>
  )
}
